<template>
  <div class="pagination">
    <ul class="pagination-list">
      <li
        v-for="pageNumber in totalPages"
        :key="pageNumber"
        class="pagination-list-item"
        :class="pageNumber === currentPage ? 'is-current' : ''"
      >
        <a
          :href="pageNumber"
          class="pagination-link"
          @click.prevent="$emit('changePage', pageNumber)"
        >{{ pageNumber }}</a>
      </li>
      <!-- current: {{ currentPage }}, per page: {{ itemsPerPage }}, total: {{ totalItems }} -->
      <!-- <button @click="$emit('changePage', 2)">change</button> -->
    </ul>
  </div>
</template>

<script>
export default {
  name: 'KfPagination',
  props: {
    totalItems: {
      type: Number,
      default: 0,
    },
    itemsPerPage: {
      type: Number,
      default: 5,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
};
</script>
